<template>
  <div
    class="fixed"
    :class="{ debug: debug }"
    :style="{ background: backgroundColor }"
  >
    <warning-message
      v-if="!screen.loaded"
      is-loading-message
    >
      {{ $t('status.loading') }}
    </warning-message>
    <warning-message
      v-else-if="todaysNowPlayingAndUpcomingShowings.length == 0"
    >
      {{ $t('showing.noShowingsToday') }}
    </warning-message>
    <div v-else-if="screen && currentShowing">
      <!-- We have a movie and showtimes-->
      <div
        class="column justify-between text-left absolute-full poster-and-showings-container"
        :style="{
          top: marginVertical + 'px ',
          bottom: marginVertical + 'px ',
          left: +marginHorizontal + 'px',
          right: +marginHorizontal + 'px',
        }"
      >
        <div class="row full-height">
          <div
            class="column justify-evenly items-center text-white text-bold text-uppercase col-auto"
            :class="$isColorDark(backgroundColor) ? 'text-white' : 'text-dark'"
            style="line-height: 1; padding: 1.5vh 4vh"
            :style="{ 'font-size': showScreenName ? '10vw': '8vw' }"
          >
            <span
              class="col q-px-sm"
              style="border-left: 0.4vh solid; border-right: 0.4vh solid;"
              :style="{ color: $isColorDark(backgroundColor) ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.5)' }"
            />
            <span
              class="col-auto q-px-md text-center text-no-wrap rotate-270 z-top absolute"
              style="max-width: 80vh;"
              :style="{ 'background-color': backgroundColor }"
            >
              <template v-if="showScreenName"> {{ screen.name }}</template>
              <template v-else-if="showMovieName">  {{ currentShowing.movie.name }}</template>

            </span>
            <span
              class="col q-px-sm"
              style="border-left: 0.4vh solid; border-right: 0.4vh solid;"
              :style="{ color: $isColorDark(backgroundColor) ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.5)' }"
            />
          </div>
          <div
            class="col bg-black relative-position"
          >
            <video
              v-if="currentShowing.movie.animatedPosterVideo"
              :key="currentShowing.movie.id"
              autoplay
              loop
              muted
              style="width: 100%; height: 100%; min-height: 50vh; object-fit: cover;"
              :style="{ 'max-height': detail ? '68vh' : '73vh' }"
              class="col"
            >
              <source
                :src="currentShowing.movie.animatedPosterVideoUrl"
                type="video/mp4"
              >
            </video>
            <q-img
              v-else
              class="col"
              :style="{ 'max-height': detail ? '68vh' : '73vh' }"
              :src="currentShowing.movie.posterImageLargeUrl"
            />

            <div
              v-if="showScreenName && showMovieName"
              class="col-auto text-left text-white text-bold ellipsis-3-lines"
              style="line-height: 1.1; margin: 0.8vh 1vh;"
              :style="fontSize"
            >
              {{ currentShowing.movie.name }}
            </div>

            <div
              class="col-auto row justify-between q-mx-md"
              style="padding: 0.5vh 0; margin: 0.5vh 1vh"
              :style="{ 'border-top': showScreenName && showMovieName ? `0.3vh solid ${currentSite.primaryColor}` : undefined }"
            >
              <div class="col-auto row justify-start items-center">
                <template v-if="currentSite.signageConfig.display_rating">
                  <rated
                    v-if="currentShowing.movie.rating"
                    :rated="currentShowing.movie.rating"
                    :rating-reason="currentShowing.movie.ratingReason"
                    :outline="false"
                    color="white"
                    text-color="dark"
                    is-font-size-responsive
                    :font-size="2.2"
                    :no-margin="false"
                    :highlight-r-rated="highlightRRated"
                    :disable-official-symbol="disableOfficialSymbol"
                    class="text-bold q-mr-md"
                  />
                  <q-chip
                    v-if="showRatingReason && currentShowing.movie.ratingReason"
                    class="text-bold"
                    square
                    color="transparent"
                    text-color="white"
                    size="2vh"
                    dense
                    style="border: solid 2px; height: auto;"
                  >
                    <div
                      class="q-py-sm q-px-none"
                      style="white-space: normal; font-size: 1vh; line-height: 1;"
                    >
                      {{ currentShowing.movie.ratingReason }}
                    </div>
                  </q-chip>
                </template>
                <template
                  v-if="showShowingBadges"
                >
                  <showing-badge
                    v-for="showingBadge in currentShowing.showingBadges.data"
                    :key="showingBadge.id"
                    class="col-auto"
                    :size="detail ? '2.2vw' : '3vw'"
                    :showing-badge="showingBadge"
                    color="white"
                  />
                </template>
              </div>
            </div>
            <div
              v-if="detail"
              class="row justify-start items-center text-uppercase"
            >
              <q-icon
                v-if="computedMoreBefore"
                name="chevron_left"
                class="text-white before-after"
              />
              <div
                v-for="(showing, index) in showings()"
                :key="showing.showingId"
                class="col-auto showing no-border-radius"
                :style="styleForShowing(showing, index)"
              >
                <div class="time">
                  {{ showing.siteTime.format("h:mm a") }}
                </div>
                <div
                  v-if="multipleMovies"
                  class="movie-name"
                >
                  {{ showing.movie.name }}
                </div>
              </div>
              <q-icon
                v-if="computedMoreAfter"
                name="chevron_right"
                class="text-white before-after"
              />
            </div>
            <div
              class="row justify-between items-center text-uppercase absolute full-width"
              style="bottom: 0; padding: 1vh"
            >
              <div
                v-if="detail"
                class="col-auto text-white rotate-180 text-bold"
                style="line-height: 1.2; writing-mode: vertical-lr; text-orientation: mixed; font-size: 2.2vh; margin-bottom: 0.6vh;"
              >
                NEXT
              </div>
              <div
                class="col column justify-starts self-center"
              >
                <div
                  class="col text-left text-white text-uppercase"
                  style="font-weight: 800; line-height: 1;"
                  :style="{ 'font-size': detail ? '2.6vh' : '3.5vh' }"
                >
                  {{ currentShowing.siteTime.format('h:mm a') }}
                </div>
                <div
                  class="col text-left text-grey text-uppercase text-italic"
                  style="font-weight: 800; font-size: 2vh;"
                >
                  Ends {{ currentShowing.siteEndTime.format("h:mm a") }}
                </div>
              </div>
              <div
                v-if="showLogo"
                class="col-auto"
              >
                <img
                  :style="{ 'height': detail ? '4vh' : '5vh' }"
                  :src="currentSite.lightLogoImageUrl"
                >
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <warning-message
      v-else-if="errorOccurred"
    >
      An error occurred
    </warning-message>
    <warning-message
      v-else-if="!screen"
    >
      {{ `Unknown Screen - ${$route.params && $route.params.screenId}` }}
    </warning-message>
    <warning-message
      v-else
    >
      Unknown Error
    </warning-message>
  </div>
</template>

<script>
import ShowingBadge from 'src/modules/admin/showing-badge/components/ShowingBadge'
import Rated from 'src/modules/consumer/components/Rated'
import WarningMessage from 'src/modules/signage/components/WarningMessage'
import CurrentShowingsSignageMixin from 'src/modules/signage/mixins/CurrentShowingsSignageMixin'
import ShowingsSignageConfigurationMixin from 'src/modules/signage/mixins/ShowingsSignageConfigurationMixin'
import { inject } from 'vue'

export default {
  name: 'ScreenPortrait',
  components: {
    ShowingBadge,
    Rated,
    WarningMessage
  },
  mixins: [CurrentShowingsSignageMixin, ShowingsSignageConfigurationMixin],
  props: {
    overrideScreenId: {
      type: Number,
      required: false,
      default: null
    },
    overrideCover: {
      type: Boolean,
      required: false,
      default: false
    },
    showScreenName: {
      type: Boolean,
      required: false,
      default () {
        const route = inject('route')
        return !(route?.query && route.query['show-screen-name'] === 'false')
      }
    },
    showMovieName: {
      type: Boolean,
      required: false,
      default () {
        const route = inject('route')
        return !(route?.query && route.query['show-movie-name'] === 'false')
      }
    },
    showShowingBadges: {
      type: Boolean,
      required: false,
      default () {
        const route = inject('route')
        return !(route?.query && route.query['show-showing-badges'] === 'false')
      }
    },
    showRatingReason: {
      type: Boolean,
      required: false,
      default () {
        const route = inject('route')
        return !(route?.query && route.query['show-rating-reason'] === 'false')
      }
    },
    detail: {
      type: Boolean,
      required: false,
      default () {
        const route = inject('route')
        return route?.query && route.query.detail === 'true'
      }
    },
    moreBefore: {
      type: Boolean,
      required: false,
      default () {
        const route = inject('route')
        return route?.query && route.query['more-before'] === 'true'
      }
    },
    moreAfter: {
      type: Boolean,
      required: false,
      default () {
        const route = inject('route')
        return route?.query && route.query['more-after'] === 'true'
      }
    }
  },
  models: {
    screen: {
      fields: ['id', 'name', 'color'],
      todaysShowings: {
        movie: 'default',
        screen: 'default',
        showingBadges: 'default',
        withinSignageThreshold: true
      },
      variables () {
        return {
          id: this.overrideScreenId || this.$route.params?.screenId
        }
      },
      immediate: true
    }
  },
  data () {
    return {
      errorOccurred: false,
      computedMoreBefore: this.moreBefore,
      computedMoreAfter: this.moreAfter
    }
  },
  computed: {
    multipleMovies () {
      return _(this.screen.todaysShowings.data).map('movie.id').uniq().value().length > 1
    },
    cover () {
      return this.overrideCover || this.$route.query.cover || false
    },
    backgroundColor () {
      return !this.screen.color ? this.currentSite.primaryColor : this.screen.color
    },
    fontSize () {
      const movieNameLetterCount = this.currentShowing.movie.name.length

      if (movieNameLetterCount > 45) {
        return 'font-size : 2.6vh'
      } else if (movieNameLetterCount > 18) {
        return 'font-size : 3.4vh'
      } else {
        return 'font-size : 4vh'
      }
    }
  },
  async mounted () {
    // Fetching the screen when in the app mode of digital-signage, sets the site_id cookie
    // This will reload the configuration data after being authenticated
    this.$handleAuthChange()
  },
  methods: {
    styleForShowing (showing, index) {
      const style = []

      if (index > 0) style.push('border-left: 0.2vh solid' + this.currentSite.primaryColor)

      if (showing.current) {
        // Current
        style.push('color:' + this.$lightenColor(this.currentSite.primaryColor, 80))
      } else if (showing.localPast) {
        // Past
        style.push('text-decoration: line-through; ' + 'color: ' + this.$lightenColor(this.currentSite.primaryColor, 20))
      } else {
        // Future
        style.push('color: ' + this.$lightenColor(this.currentSite.primaryColor, 60))
      }

      return style.join(';')
    },

    showings () {
      const now = new Date()

      let showings = [...this.screen.todaysShowings.data]

      let moreBefore = false
      let moreAfter = false

      while (showings.length > 3) {
        if (showings[0].endTime < now) {
          showings = showings.slice(1)
          moreBefore = true
        } else {
          showings = showings.slice(0, showings.length - 1)
          moreAfter = true
        }
      }

      this.computedMoreBefore = moreBefore
      this.computedMoreAfter = moreAfter

      return showings
    }
  }
}
</script>

<style scoped>
.fixed {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
}
.debug .poster-and-showings-container > div {
  border: solid 1px red;
}

.showing {
  font-size: 1.2vh;
  padding: 0 1vw;
  overflow: hidden;
  margin-left: 0.5vh;
  margin-bottom: 0.5vw;
}
.before-after {
  font-size: 1vw;
  font-weight: bold;
  margin-bottom: 1vw;
}
.debug .showing {
  border: solid 1px yellow;
}
.time {
  font-size: 2vh;
  font-weight: 800;
  line-height: 1;
}
</style>
